// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Personal_dualInputsRow__kEGYk, .Personal_bankInfoRow__IlwSS{
    display: flex;
    margin-bottom: 15px;
}
.Personal_name__1uJxc input{
    width: 215px;
}
.Personal_singleLineInput__C1LTe{
    display: block !important;
    margin-bottom: 15px;
}
.Personal_singleLineInput__C1LTe input{
    width: calc(100% - 50px);
}
@media(max-width: 930px){
    .Personal_dualInputsRow__kEGYk{
        display: block;
        margin-bottom: 0;
    }
    .Personal_name__1uJxc{
        display: block;
        margin-bottom: 15px;
    }
    .Personal_name__1uJxc input{
        width: calc(100% - 50px);
    }
}
.Personal_bankInfoRow__IlwSS{
    margin-top: 25px;
    align-items: center;
}
.Personal_bankInfoLabel__0qKq-{
    position: relative;
    top: -2px;
    margin-left: 2px;
    color: #1F363D;
    font-size: 16px;
    font-family: 'Gotham Medium', serif;
}
.Personal_bankIcon__-d2ZE{
    position: relative;
    top: 3px;
    height: 20px;
    width: 20px;
    margin-right: 10px;
}
.Personal_exclamation__dZhrz{
    position: relative;
    top: 1px;
    height: 16px;
    width: 18px;
    margin-left: 6px;
}
.Personal_checkmark__kkUl8{
    position: relative;
    top: 2.5px;
    height: 16px;
    width: 16px;
    margin-left: 7px;
}
.Personal_bankInfoButton__Krw41{
    height: 38px;
    margin-left: auto;
    padding: 0 30px;
    font-size: 14px;
    border: 1px solid #40798C66;
}
@media(max-width: 400px){
    .Personal_bankIcon__-d2ZE{
        margin-right: 5px;
    }
    .Personal_exclamation__dZhrz, .Personal_checkmark__kkUl8{
        margin-left: 3px;
    }
    .Personal_bankInfoButton__Krw41{
        padding: 0 15px;
    }
}
.Personal_button__gwY56{
    width: 261px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: 35px;
}`, "",{"version":3,"sources":["webpack://./src/components/profile/Personal.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI;QACI,cAAc;QACd,gBAAgB;IACpB;IACA;QACI,cAAc;QACd,mBAAmB;IACvB;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".dualInputsRow, .bankInfoRow{\n    display: flex;\n    margin-bottom: 15px;\n}\n.name input{\n    width: 215px;\n}\n.singleLineInput{\n    display: block !important;\n    margin-bottom: 15px;\n}\n.singleLineInput input{\n    width: calc(100% - 50px);\n}\n@media(max-width: 930px){\n    .dualInputsRow{\n        display: block;\n        margin-bottom: 0;\n    }\n    .name{\n        display: block;\n        margin-bottom: 15px;\n    }\n    .name input{\n        width: calc(100% - 50px);\n    }\n}\n.bankInfoRow{\n    margin-top: 25px;\n    align-items: center;\n}\n.bankInfoLabel{\n    position: relative;\n    top: -2px;\n    margin-left: 2px;\n    color: #1F363D;\n    font-size: 16px;\n    font-family: 'Gotham Medium', serif;\n}\n.bankIcon{\n    position: relative;\n    top: 3px;\n    height: 20px;\n    width: 20px;\n    margin-right: 10px;\n}\n.exclamation{\n    position: relative;\n    top: 1px;\n    height: 16px;\n    width: 18px;\n    margin-left: 6px;\n}\n.checkmark{\n    position: relative;\n    top: 2.5px;\n    height: 16px;\n    width: 16px;\n    margin-left: 7px;\n}\n.bankInfoButton{\n    height: 38px;\n    margin-left: auto;\n    padding: 0 30px;\n    font-size: 14px;\n    border: 1px solid #40798C66;\n}\n@media(max-width: 400px){\n    .bankIcon{\n        margin-right: 5px;\n    }\n    .exclamation, .checkmark{\n        margin-left: 3px;\n    }\n    .bankInfoButton{\n        padding: 0 15px;\n    }\n}\n.button{\n    width: 261px;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 35px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dualInputsRow": `Personal_dualInputsRow__kEGYk`,
	"bankInfoRow": `Personal_bankInfoRow__IlwSS`,
	"name": `Personal_name__1uJxc`,
	"singleLineInput": `Personal_singleLineInput__C1LTe`,
	"bankInfoLabel": `Personal_bankInfoLabel__0qKq-`,
	"bankIcon": `Personal_bankIcon__-d2ZE`,
	"exclamation": `Personal_exclamation__dZhrz`,
	"checkmark": `Personal_checkmark__kkUl8`,
	"bankInfoButton": `Personal_bankInfoButton__Krw41`,
	"button": `Personal_button__gwY56`
};
export default ___CSS_LOADER_EXPORT___;
